import { RawAxios } from './Axios';
import { API_ROOT } from './Constants';
const API_PATHS = {
    CSRF_TOKEN: `${API_ROOT}/csrf_token`,
};
async function getCsrfToken() {
    return (await (await RawAxios()).get(API_PATHS.CSRF_TOKEN)).data;
}
export default { getCsrfToken };
